import React from 'react'
import Modal from 'react-bootstrap/Modal'

const IlceModal = (props) => {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      style={{
        userSelect: 'none',
      }}
      size={20}
      //   backdrop='static'
      centered
    >
      <Modal.Body className='ilceModal'>
        {props?.ilceler?.map((item) => (
          <div
            className='ilceItem'
            key={item.ilce_id}
            onClick={() => {
              props.setIlce(item.ilce_adi)
              props.setIlceId(item.ilce_id)
              if (item.ice_id !== 684) {
                props.setMahalleid(null)
                props.setMahalleAdi('Seçiniz...')
              }
              props.onHide()
            }}
          >
            {item.ilce_adi}
          </div>
        ))}
        <div
          style={{ position: 'absolute', top: '15px', right: '15px' }}
          onClick={props.onHide}
        >
          X
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default IlceModal
